import virtualacc from "../Assets/virtualacc.svg";
import ServiceBG from "../Assets/splashfinacc.svg";
import BusinessSupport from "../Assets/businesssupport.svg";
import DueDiligence from "../Assets/duedilligence.svg";
import TaxAdvisory from "../Assets/taxadvisory.svg";
import PeopleManagement from "../Assets/peoplemanagement.svg";

let servicesData = {
    "finAcc":{
        "title":"Finance and Accounting",
        "titleDesc":[
            "Reliable and Up-to-date, accounting services with its collaborative, customized engagement\n" +
            "                        approach and industry specific expertise help you align better with your business priorities and take timely and informed decisions",
            "We uses proprietary technology and systems designed to expedite project delivery times and ensure\n" +
            "                        accuracy across all of our services, including traditional accounting and bookkeeping functions as well as online and cloud-based accounting practices."
        ],
        "subItems":[
            {
                "title":"Virtual Accounting Services",
                "itemDesc":[
                    "Virtual Accounting Services are from an experienced, committed team offering virtual accounting\n" +
                    "                        functions to manage your accounts payable, accounts receivable, projects, general ledger postings,\n" +
                    "                        bank reconciliations, preparation of financial statements, and MIS Reporting* for Small and\n" +
                    "                        Medium Enterprise (SME) Sector.",
                    "Our ultimate goal is to be a value addition to your business for making you focus on your core\n" +
                    "                        business functions, let us provide the accounting, Tax compliance services.",
                    "AUDIGO provides value added service in the area of maintaining books of accounts, providing\n" +
                    "                        reconciliation reports, risk analysis, internal audits and all other routine office book keeping."
                ],
                "banner":virtualacc
            }
        ],
        "highlights":[
            "Designing and implementing financial systems and planning",
            "Budgets and forecasts",
            "Digital transformation",
            "Cost accounting & payables",
            "Revenue Accounting & Receivables",
            "Payroll",
            "Month end close",
            "Reconciliations",
            "Fixed assets accounting",
            "MIS",
            "Management reporting",
            "Financial reporting",
            "Consolidation"
        ],
        "banner":ServiceBG
    },
    "businessSuppServices":{
        "title":"Business Support Services",
        "titleDesc":[
            "Audigo will build successful solutions to fit your needs. Whether you are a global conglomerate or a closely held business"
        ],
        "highlights":[
            "Internal controls",
            "Research and Analysis",
            "Inventory Management",
            "Expense Management"
        ],
        "banner":BusinessSupport
    },
    "dueDiligence":{
        "title":"Due Diligence",
        "titleDesc":[
            "Audigo will Identify, Analyse, Control, Transfer, Reduce and Access the Due Diligence and provide to manage" +
            " your business risks with tailored and thorough due diligence services for your investments, business partners," +
            " suppliers, employees and clients."
        ],
        "highlights":[
            "Company Law",
            "Foreign Exchange Management Act",
            "Audit the target enterprise’s financial performance and regulatory compliance records",
            "Analyze financial metrics",
            "Assess and present the findings objectively",
            "6Registrations under Various Acts in India"
        ],
        "banner":DueDiligence
    },
    "taxAdvisory":{
        "title":"Tax Advisory",
        "titleDesc":[
            "Tax investigations are increasing in number all the time. Obtaining the best advice when you need it can " +
            "save a lot of time and money – not to mention, stress."
        ],
        "highlights":[
            "Direct Tax services",
            "Indirect Tax services",
            "Transfer Pricing",
            "US Tax",
            "Financial Services",
            "Transaction Tax",
            "Global Mobility Services",
            "Annual return filings",
            "Quarterly estimate computations",
            "Franchise returns and annual reports",
            "HST/GST/QST tax returns",
            "Payroll tax returns"
        ],
        "banner":TaxAdvisory
    },
    "peopleManagememt":{
        "title":"People Management",
        "titleDesc":[
            "Audigo offer tailored recruitment, payroll management and hiring solutions, supporting your global expansion."
        ],
        "highlights":[
            "Executive recruitment",
	        "Employment Law",
            "Professional Employer Organization",
            "Payroll processing",
            "Generation and distribution of pay slips",
            "Employee expense reimbursements",
            "Full and final settlement"
        ],
        "banner":PeopleManagement
    }
};

export default servicesData;


// WEBPACK FOOTER //
// ./src/StaticData/servicesDataJSON.js